import { archivedUrls } from "./archivedUrls";
import { deliveredUrl } from "./deliveredUrls";
import { inProcessUrl } from "./inProcessReturnsUrl";
import { recycleBinUrl } from "./recycleBinUrl";
import { returnStatusUrls } from "./returnStatusUrls";
import { returnsUrl } from "./returnsUrl";

export class SSR {
    static readonly RETURNS = new returnsUrl();
    static readonly IN_PROCESS = new inProcessUrl();
    static readonly DELIVERED = new deliveredUrl();
    static readonly ARCHIVED = new archivedUrls();
    static readonly RECYCLE_BIN = new recycleBinUrl();
    static readonly RETURN_STATUS = new returnStatusUrls();
}